import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Popconfirm, Table,Alert,Popover,Space} from 'antd';
import {useParentState} from 'utils';
import { DeleteOutlined,InfoCircleOutlined } from '@ant-design/icons';
import MyTable from 'components/table/table';
import _ from 'lodash';
import {getFormItem,getInput} from './form';
import Language,{useLanguage} from '../language';


export const MyPopover = ({id})=><Popover 
                placement="right" 
                overlayStyle={{maxWidth:300,width:300}} 
                trigger="click"
                content={<div><Language id={id}/></div>
                } 
              >
               <InfoCircleOutlined /> 
              </Popover>



export default ({
  columns:_columns,
  rowKey,
  data:_data,
  setData:_setData,
  // schema,
  parentData,
  ...other
  }) => {
  const [data, setData] = useParentState(_data,_setData);
 
 
 
 
 
 const handleDelete = (record) => {
    const newData = [...data];
    const index = newData.findIndex((item) => record?.[rowKey] === item?.[rowKey]);     
    newData.splice(index, 1,);    
    setData(newData);
  };

  const handleSave = (rowId,key,value) => {    
    const newData = [...data];
    const index = newData.findIndex((item) => rowId === item?.[rowKey]);    
    newData.splice(index, 1, {
      ...newData[index],
      [key]:value
    });
    
    setData(newData);
  };
  
  
  const pcolumns = _columns.map((col) => {
    const {filters,options}=col;
    if (!col.editable) {
      return col;
    }
    
    
    return {
      ...col,
      name:<Space><MyPopover id={col?.info??"NA"}/></Space>,
      render: (value,{[rowKey]:id,disabled,deleteDisabled,selectDisabled,errors,...other}) => {
        // const property = schema.properties[col?.key];
        // const { options:_options} = property||{};
          // console.log("_options",_options)
        
        return<>
        {
          getInput({...col,disabled,selectDisabled,value,onChange:(e)=>handleSave(id,col?.key,e),
            options:options?(_.isFunction(options)&&options(parentData,other))||options:filters&&filters.map(({text,value})=>({key:value,label:text,value}))
            // options:options?(_.isFunction(options)&&options(other))||options:filters&&filters.map(({text,value})=>({key:value,label:text,value})),
            // options:(_.isFunction(_options)&&_options(getFieldValue))||_options
            })
          // {getInput({...inputs,ref,type,format,showSearch,options:(_.isFunction(_options)&&_options(getFieldValue))||_options})}
          }
        
        {errors&&errors[col?.key]&&<Alert type="error" showIcon={true} banner={false} message={<Language id={errors[col?.key]}/>}/>}
      </>
      },
    };
  });
  
  const columns=[...pcolumns,
  {
    title: '',
    key: 'action',
    visible:true,
    render: (_, record) => (
               <Popconfirm
            title=<Language id={"DeleteMessage"}/>
            onConfirm={() => handleDelete(record)}
            okText=<Language id={"Yes"}/>
            cancelText=<Language id={"No"}/>
          >
            <Button
              type="link"
              shape="circle"
              disabled={record.disabled||record?.deleteDisabled}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
    ),
  }]
  
  return (
    <div>
    
      <MyTable              
        bordered
        data={data}
        columns={columns}
        rowKey={rowKey}
        {...other}
      />
    </div>
  );
};
